import { useEvent } from "@/context/event-context";
import { trackEvent } from "@/hooks/use-analytics";

const MidCta = () => {
  const { event } = useEvent();

  const tagline = event?.theme_config?.tagline || "The Peak of Summer";

  return (
    <section data-nav-theme="dark" className="bg-ink text-white py-[6vw] text-center">
      <div className="max-w-[1600px] mx-auto px-[4vw]">
        <h2
          className="font-display leading-[1.1] mb-8"
          style={{
            fontSize: "var(--section-size, clamp(1.5rem, 3vw, 2.5rem))",
            fontWeight: "var(--section-weight, 400)",
            letterSpacing: "var(--section-tracking, 0.1em)",
            fontStyle: "var(--section-style, normal)" as any,
            textTransform: "var(--hero-transform, uppercase)" as any,
          }}
        >
          Don't Miss the Launch of Summer
        </h2>
        <a
          href="#tickets"
          onClick={() => trackEvent("select_content", { content_type: "cta", content_id: "mid_book_tickets" })}
          className="inline-block bg-white text-ink hover:bg-gold hover:text-white transition-colors active:scale-[0.97]"
          style={{
            fontSize: "var(--cta-size, 0.75rem)",
            fontWeight: "var(--cta-weight, 600)",
            letterSpacing: "var(--cta-tracking, 0.1em)",
            padding: "var(--cta-padding, 1.25rem 2.5rem)",
            borderRadius: "var(--cta-radius, 0)",
            textTransform: "uppercase" as any,
            fontFamily: "var(--font-sans)",
          }}
        >
          Book Tickets Now
        </a>
      </div>
    </section>
  );
};

export default MidCta;
